import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 5DF1214D-79EC-4EA0-B435-CB73B877DCA9
 * name home-variant-outline
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-variant-outline.svg
 * tags
 * - Home Automation 
 */
export const HomeVariantOutlineIcon = createSvgIcon(<><path d="M9,13H15V19H18V10L12,5.5L6,10V19H9V13M4,21V9L12,3L20,9V21H4Z" /></>, 'HomeVariantOutlineIcon');
export default HomeVariantOutlineIcon